import React from "react";
import MasterLayout from "../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../components/Breadcrumb";
import ManageDashboardLayer from "../../../components/Admin/ManageDashboardLayer";

const ManageDashboard = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Add Category' />

        {/* BlankPageLayer */}
        <ManageDashboardLayer />
      </MasterLayout>
    </>
  );
};

export default ManageDashboard;